export var reduxKey = '@@WHO';
export var streamType = '@@WHO';
export var actionKey = '@@WHO';
//# sourceMappingURL=constants.js.map